import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Params, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { ReportsManagerService } from '../service/reports-manager-service';

@Component({
  selector: 'app-report-manager',
  templateUrl: './report-manager.component.html',
  styleUrls: ['./report-manager.component.css']
})
export class ReportManagerComponent implements OnInit {
  param: any;
  reports: any;

  constructor(private router: Router, protected activatedroute: ActivatedRoute,private data : ReportsManagerService) { }

  ngOnInit() {
    console.log('manger log');

    // this.router.params.subscribe(res=>{
    //   if(res)
    //   console.log(res) 
    // });
    // setTimeout(() => {

    //   console.log(this.router.snapshot);
    // }, 4000);
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe((event: NavigationEnd) => {
      const parts = event.url.split('/');
      const url = parts[2];
      console.log(url,'url');
     this.reports= JSON.parse(sessionStorage.getItem('user_reports')).result
     console.log(this.reports,"asdasdas")
      switch (url) {
        case "dashboards": {
          let dashborad_type:any = this.activatedroute.snapshot.queryParams.tab;
          console.log(dashborad_type);
          let data=this.reports.filter(item=>item.module==1 && item.submodule==2 && item.title.includes(dashborad_type))
          
          if(dashborad_type=='inbound'){
            this.data.getReportsData({data,dashborad_type}).subscribe((res:any)=>{
              console.log(res);
            })
          }
          if(dashborad_type=='outbound'){
            this.data.getReportsData({data,dashborad_type}).subscribe((res:any)=>{
              console.log(res);
            })
          }
          
      
        }
          break;
        case "agent": {
          const url3=parts[3]
          const agentgroupid=parts[4]
          if(url3=='agent-report'){
            let data=this.reports.filter(item=>item.module==2 && item.submodule==2)
            this.data.getReportsData({data,agentgroupid}).subscribe((res:any)=>{
              console.log(res);
            })
          }else{
            let data=this.reports.filter(item=>item.module==2 && item.submodule==1)
            this.data.getReportsData({data,agentgroupid}).subscribe((res:any)=>{
              console.log(res);
            })
          }
        }
          break;
        case "campaigns": {
          const url3=parts[3]
          const campaigngroupid=parts[4].split('?')[0]
          let report_type:any = this.activatedroute.snapshot.queryParams.tab;
          if(url3=='reportout'){
            if(report_type=='detail'){
              let data=this.reports.filter(item=>item.module==5 && item.submodule==3)
              this.data.getReportsData({data,campaigngroupid}).subscribe((res:any)=>{
                console.log(res);
              })
            }else if(report_type=='summary'){
              let data=this.reports.filter(item=>item.module==5 && item.submodule==2)
              this.data.getReportsData({data,campaigngroupid}).subscribe((res:any)=>{
                console.log(res);
              })
            }
           
          }
        }
          break;
        case "lead": {
          const url3=parts[3]
          const leadgroupid=parts[4]
          if(url3=='lead-report'){
            let data=this.reports.filter(item=>item.module==4 && item.submodule==2)
            this.data.getReportsData({data,leadgroupid}).subscribe((res:any)=>{
              console.log(res);
            })
          }
        }
          break;
        case "listdid": {
          const url3=parts[3]
          const didgroupid=parts[4]
          if(url3=='did-report'){
            let data=this.reports.filter(item=>item.module==3 && item.submodule==2)
            this.data.getReportsData({data,didgroupid}).subscribe((res:any)=>{
              console.log(res);
            })
          }
        }
          break;
        case "reports": {

        }
          break;
        default:
          break;
      }
      console.log('URL changed:', event.url);
      console.log('Route params:', this.activatedroute.snapshot.queryParams.tab);
    });
    // this.activatedroute.queryParams.subscribe((params: Params) => {
    //   // Handle parameter changes here
    //   console.log('Route params changed:', params);
    // });
  }

}
